<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<cas-topbar></cas-topbar>
<cas-project-memberships
  [projectId]="projectId"
  [showReturnButton]="true"
  returnLabel="Return to Project"
  (goBack)="returnToProject()"
></cas-project-memberships>
